module.exports = __webpack_public_path__ + "img/imba_force_staff.fed7cb66.png";